export async function fetchLogin(obj: { email: string; password: string }) {
  await $fetch('/customer/login', {
    server: false,
    method: 'POST',
    credentials: 'include',
    baseURL: useRuntimeConfig().public.apiBaseURL,
    body: {
      username: obj.email,
      password: obj.password,
      client: useRuntimeConfig().public.client,
    },
  })
}
